import { create } from "zustand"
import { persist } from "zustand/middleware"

interface Location {
  latitude: number
  longitude: number
  accuracy: number
  timestamp: number
}

interface UserState {
  location: Location | null
  isOnline: boolean
  platform: "rideshare" | "taxi" | "multiple"
  notifications: boolean
  onboardingCompleted: boolean
  preferredCity: "la" | "nyc" | "chi" | "dfw" | "atl" | "sf" | "mia" | "sea" | "den" | "phx" | "hou" | "sat" | "aus" | "elp" | "cst"

  // Stats
  todayEarnings: number
  weeklyEarnings: number
  todayTrips: number
  timeSaved: number
  closuresAvoided: number

  // Actions
  setLocation: (location: Location) => void
  setPlatform: (platform: UserState["platform"]) => void
  setOnline: (online: boolean) => void
  setNotifications: (enabled: boolean) => void
  completeOnboarding: (city: UserState["preferredCity"]) => void
  resetOnboarding: () => void
  updateStats: (stats: Partial<Pick<UserState, "todayEarnings" | "weeklyEarnings" | "todayTrips" | "timeSaved" | "closuresAvoided">>) => void
}

export const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      location: null,
      isOnline: false,
      platform: "rideshare",
      notifications: true,
      onboardingCompleted: false,
      preferredCity: "la",

      todayEarnings: 0,
      weeklyEarnings: 0,
      todayTrips: 0,
      timeSaved: 0,
      closuresAvoided: 0,

      setLocation: (location) => set({ location }),
      setPlatform: (platform) => set({ platform }),
      setOnline: (online) => set({ isOnline: online }),
      setNotifications: (enabled) => set({ notifications: enabled }),
      completeOnboarding: (city) => set({ onboardingCompleted: true, preferredCity: city }),
      resetOnboarding: () => set({ onboardingCompleted: false }),
      updateStats: (stats) => set((state) => ({ ...state, ...stats })),
    }),
    { name: "ezer-user-store" }
  )
)
